/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InsightsSummaryResponseDto } from '../../models/insights-summary-response-dto';

export interface AdminInsightsControllerGetSummaryV1$Params {
}

export function adminInsightsControllerGetSummaryV1(http: HttpClient, rootUrl: string, params?: AdminInsightsControllerGetSummaryV1$Params, context?: HttpContext): Observable<StrictHttpResponse<InsightsSummaryResponseDto>> {
  const rb = new RequestBuilder(rootUrl, adminInsightsControllerGetSummaryV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InsightsSummaryResponseDto>;
    })
  );
}

adminInsightsControllerGetSummaryV1.PATH = '/v1/admin/insights/summary';
